import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/empleados-actualizar-antiguedades';

/**
 * POST Actualizar Antiguedad
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postActualizarAntiguedad = async () => {
  try {
    const response = await API.post(baseURI, {});
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
